import React from "react";
import { Section, Overline, H1, H2 } from "@/components/ui-kit";

export default function Terms() {
  return (
    <Section className="pt-20 md:pt-28 pb-24">
      <Overline>Terms of Use</Overline>
      <H1 className="mt-4">Terms of Use</H1>
      <div className="prose prose-invert max-w-3xl mt-10 space-y-6 text-neutral-300 text-sm leading-relaxed">
        <p>Use of this website is governed by these Terms. By using brightsidecapital.net you agree to these Terms.</p>
        <H2 className="text-lg">No Offer or Solicitation</H2>
        <p>Information on this website is for general informational purposes only and is not an offer to sell or a solicitation of an offer to buy any security or real estate interest. Any investment opportunity is offered only through appropriate documentation and in compliance with applicable laws.</p>
        <H2 className="text-lg">No Advice</H2>
        <p>Nothing on this site constitutes legal, tax, financial, or investment advice. You should consult licensed advisors for your situation.</p>
        <H2 className="text-lg">Property Submissions</H2>
        <p>Submitting property details does not create a contract or guarantee an offer. All transactions are subject to inspection, title, lender, and legal review.</p>
        <H2 className="text-lg">Limitation of Liability</H2>
        <p>The website and its contents are provided "as is" without warranty. We are not liable for damages arising from use of the site.</p>
        <p className="text-xs text-neutral-500 pt-8">Replace with jurisdiction-specific terms as needed.</p>
      </div>
    </Section>
  );
}
